import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MyCalendar = ({ startDate, setStartDate, error, disabled }) => {

    return (<div>
        <DatePicker disabled={disabled} className={error ? "error" : ''} selected={startDate} dateFormat={'dd/MM/yyyy'} onChange={(date) => setStartDate(date)} />
        {error && <p style={{ margin: 0, fontWeight: '500', fontSize: '15px', color: '#D90000' }}>{'Date is required.'}</p>}
    </div>);
}

export default MyCalendar